import { Box, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EmailIcon from '@material-ui/icons/Email';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';

import { RichText } from 'prismic-reactjs';
import PropTypes from 'prop-types';
import {
  LinkedinShareButton,
  TwitterShareButton,
  FacebookShareButton,
  WhatsappShareButton,
  EmailShareButton,
} from 'react-share';

import { Section } from '@/src/components/organisms';
import { WsyiwygViewer } from '@/src/components/widgets';

import { Hero, SidebarNewsletter, Latest } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100%',
  },
  socialIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.text.primary,
    '&:last-child': {
      marginRight: 0,
    },
  },
}));

export default function BlogPost({ doc = {} }) {
  const classes = useStyles();

  const { data = {}, uid } = doc;
  const { date, title, description, cover = {}, author = {}, content = {}, categories = [] } = data;

  const url = `https://${process.env.NEXT_PUBLIC_VERCEL_URL}/blog/post/${uid}`;

  return (
    <div className={classes.root}>
      <Hero
        date={date}
        title={RichText.asText(title)}
        description={description}
        cover={cover.url || '/images/blog-post-cover-placeholder.png'}
        author={author?.data}
        categories={categories}
      />
      <Section>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <WsyiwygViewer>
              <RichText render={content} />
            </WsyiwygViewer>
            <Box mt={8}>
              <Typography variant="body1" color="textPrimary" gutterBottom>
                Compartilhe:
              </Typography>
              {/* TODO: Must work on a social share repeatable component */}
              <LinkedinShareButton
                url={url}
                title={title[0]?.text}
                summary={description}
                source="Eskolare.com"
                className={classes.socialIcon}>
                <LinkedInIcon />
              </LinkedinShareButton>
              <FacebookShareButton url={url} quote={title[0]?.text} className={classes.socialIcon}>
                <FacebookIcon />
              </FacebookShareButton>
              <TwitterShareButton url={url} title={title[0]?.text} className={classes.socialIcon}>
                <TwitterIcon />
              </TwitterShareButton>
              <WhatsappShareButton url={url} title={title[0]?.text} className={classes.socialIcon}>
                <WhatsAppIcon />
              </WhatsappShareButton>
              <EmailShareButton
                url={url}
                subject={title[0]?.text}
                body={description}
                className={classes.socialIcon}>
                <EmailIcon />
              </EmailShareButton>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Latest />
            <SidebarNewsletter />
          </Grid>
        </Grid>
      </Section>
    </div>
  );
}

BlogPost.propTypes = {
  doc: PropTypes.object,
};
